import React from "react";

type SkeletonProps<T extends React.ElementType> = {
  as?: T;
  className?: string;
  height?: string;
  width?: string;
  rounded?: boolean;
} & Omit<
  React.ComponentPropsWithoutRef<T>,
  "as" | "className" | "height" | "width" | "rounded"
>;

export function Skeleton<T extends React.ElementType = "div">({
  className,
  as,
  height = "h-full",
  width = "w-full",
  rounded = true,
  ...rest
}: SkeletonProps<T>) {
  const Component = as || "div";

  return (
    <Component
      className={`bg-skeleton max-w-full animate-pulse ${height} ${width} ${rounded ? "rounded-sm" : "rounded-none"} ${className ?? ""}`}
      {...rest}
    />
  );
}
